import { createFaq, updateFaq } from '../../../../../api/AccountSetup';
import { getSubscriptionDetail } from '../../../../../common/CommonFunction';
import ToastNotification from '../../../../../common/ToastNotification';

const faqAddORUpdate = async ({
  questionsList,
  setQuestionsList,
  faqList,
  allquestionsList,
  navigate,
  setDisable,
  isSettings = false,
  fetchAllFaq,
  pathname,
  fetchAllDocuments,
  setFaqList
}: any) => {
  const companyUuid = sessionStorage.getItem('companyUuid');
  const shopId = sessionStorage.getItem('shopId');
  const businessType = sessionStorage.getItem('businessType');
  setDisable(true);
  const newQuestionList = questionsList.map((info: any) => {
    return {
      question: info.question,
      answer: info.answer
    };
  });

  const updateQuestionListWithID = questionsList.filter(
    (ques: any) => 'uuid' in ques && typeof ques.uuid === 'string' && ques.uuid.trim() !== ''
  );

  const updateQuestionListWithoutID = questionsList.filter((ques: any) => ques.uuid === null);

  const faqInfo = [
    {
      uuid: null,
      faq: newQuestionList
    }
  ];
  const changedFAQs = updateQuestionListWithID.filter((question: any) => {
    const matchedQuestion = allquestionsList.find((item: any) => item.uuid === question.uuid);
    return (
      matchedQuestion &&
      (matchedQuestion.question !== question.question || matchedQuestion.answer !== question.answer)
    );
  });

  const newAddedFaqs = [
    {
      uuid: null,
      faq: updateQuestionListWithoutID
    }
  ];

  const updateFaqInfo = {
    createFaqs: [...faqList, ...newAddedFaqs],
    updateFaqs: changedFAQs
  };

  if (questionsList.length > 0) {
    if (updateQuestionListWithID.length > 0) {
      try {
        const response = await updateFaq(updateFaqInfo, companyUuid ? companyUuid : '');
        if (response.ok) {
          const data = await response.json();
          ToastNotification({
            message: data.message
          });

          setDisable(false);
          getSubscriptionDetail(businessType, shopId);
          if (!isSettings) {
            if (pathname !== '/settings/faq') {
              navigate('/account-setup/widgets');
              setQuestionsList([]);
            }
          } else {
            setQuestionsList([]);
            setFaqList([]);
            fetchAllFaq();
            fetchAllDocuments();
          }
        } else {
          const errorData = await response.json();
          ToastNotification({
            message: errorData.message,
            type: 'warning'
          });
          setDisable(false);
        }
      } catch (error: any) {}
    } else if (newQuestionList.length > 0) {
      try {
        const faqPayload = {
          document: faqList.length > 0 ? faqList : faqInfo
        };
        const response = await createFaq(faqPayload, companyUuid ? companyUuid : '');
        if (response.ok) {
          const data = await response.json();
          ToastNotification({
            message: data.message
          });
          setDisable(false);
          getSubscriptionDetail(businessType, shopId);
          if (!isSettings) {
            if (pathname !== '/settings/faq') {
              navigate('/account-setup/widgets');
              setQuestionsList([]);
            }
          } else {
            setQuestionsList([]);
            setFaqList([]);
            fetchAllFaq();
            fetchAllDocuments();
          }
        } else {
          const errorData = await response.json();
          ToastNotification({
            message: errorData.message,
            type: 'warning'
          });
          setDisable(false);
        }
      } catch (error: any) {}
    }
  } else {
    ToastNotification({
      message: 'Please add faq',
      type: 'error'
    });
    setDisable(false);
  }
};
export default faqAddORUpdate;
